<template>
  <div class="cm_search_list">
    <!-- 主列表 -->
    <div :class="mobileClass('common_width')" v-loading="loading" style="min-height:500px">
      <div class="cm_left_list">
        <div class="cm_news_list">
          <!-- 标题 -->
          <div class="cm_news_list_title">
            <h3>搜索结果</h3>
            <span>您搜索到的{{childKeywords}}</span>
          </div>
          <!-- 内容 -->
          <div>
            <ul class="cm_news_list_content" v-if="dataList.length>0">
              <li
                v-for="(item) in dataList"
                :key="item.NEWS_ID"
                @click="toDetail(item.NEWS_ID,JSON.stringify({channelId:item.TEMPLATE_ID}))"
              >
                <h3>{{item.TITLE}}</h3>
                <div class="cm_news_list_content_time">
                  <span>{{item.SOURCE}}</span>
                  <span>{{item.PUBLISH_DATE}}</span>
                </div>
              </li>
            </ul>
            <div v-else class="cm_notice_content">没有更多数据</div>
            <div class="cm_list_pagination" v-if="totalPage>1">
              <el-pagination
                background
                layout="prev, pager, next"
                :page-count="totalPage"
                @current-change="httpPost"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="cm_right_list">
        <div class="cm_notice_container">
          <!-- 标题 -->
          <div class="cm_notice_title">
            <h3>通知公告</h3>
            <router-link :to="{path:'/list',query:{urlData:JSON.stringify(leftSend)}}">MORE+</router-link>
          </div>
          <!-- 内容 -->
          <div>
            <ul class="cm_work_content">
              <li
                v-for="item in noticeDataList"
                :key="item.NEWS_ID"
                @click="toDetail(item.NEWS_ID,leftSend)"
              >
                <h4>{{item.TITLE}}</h4>
                <span>{{cutDate(item.PUBLISH_DATE)}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    //这里存放数据
    return {
      dataList: [],
      noticeDataList: [],
      currentPage: "",
      totalPage: "",
      childKeywords:this.$route.query.keywords,
      // sendData: JSON.parse(this.$route.query.keyword),
      sendData: {keywords:JSON.parse(this.$route.query.keywords)},
      leftSend:{
        data:{
          "channelId":"announcements",
          "showCount":7
        },
        name:"通知公告",
        type:"Notice"
      },
      windowWidth:document.documentElement.clientWidth,
      loading:true
    };
  },
  //监听属性 类似于data概念
  computed: {
    cutDate:function(date){
      return (date)=>date.substring(5)
    },
    mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },

  },
  //监控data中的数据变化
  watch: {
    '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
    },
    $route: function (to, from) {
      this.httpPost();
    },
    $route:{
      handler:function(old,newData){
        this.childKeywords=this.$route.query.keywords
        this.sendData = {keywords:JSON.parse(this.$route.query.keywords)}
        this.httpPost();
    },
      deep:true
    }
  },
  //方法集合
  methods: {
    toDetail(ID, data) {
      this.$router.push({
        path: "/detail/" + ID,
        query: { parentData: JSON.stringify(data) },
      });
    },

    httpPost(page) { 
      var cData = this.sendData;
      cData.showCount=10;
      if (page != "" && page != undefined && page != null && page != NaN) {
        this.data.data.currentPage = page;
        cData = this.sendData;
        cData.showCount=10;
      }
      this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: "post",
        data: cData,
      }).then(({ data }) => {
        if (data.data != "" && data.data != undefined && data.data != null) {
          this.dataList = data.data.pdList;
          this.currentPage = data.data.currentPage;
          this.totalPage = data.data.totalPage;
          this.loading = false
        }
      });
    },
    httpPost2() {
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: "post",
        data: this.leftSend.data,
      }).then(({ data }) => {
        if (data.data != "" && data.data != undefined && data.data != null) {
          this.noticeDataList = data.data.pdList;
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.httpPost();
    this.httpPost2();
  },

};
</script>
<style scoped>
.cm_notice_content{
  margin:20px;
  font-size:25px;
}
.cm_search_list {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.common_width {
  width: 1200px;
  display: flex;
  justify-content: space-between;
}
.cm_left_list {
  width: 70%;
}
.cm_news_list {
  padding: 0 30px;
  width: 100%;
  min-height: 100%;
  background: #fff;
}
.cm_news_list_title {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #4379d3;
}
.cm_news_list_title > h3 {
  font-size: 20px;
  font-weight: 500;
  color: #4379d3;
}
.cm_news_list_title > span {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.cm_news_list_content {
  min-height: 500px;
}
.cm_news_list_content > li {
  width: 100%;
  border-bottom: 1px solid #dedede;
  padding: 20px 0;
  cursor: pointer;
}
.cm_news_list_content > li:hover > h3 {
  color: #4379d3;
}
.cm_news_list_content > li > h3 {
  font-size: 18px;
  font-weight: 600;
  color: #565656;
  margin-bottom: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cm_news_list_content_time {
  display: flex;
  justify-content: space-between;
}
.cm_news_list_content_time > span {
  font-size: 14px;
  font-weight: 400;
  color: #a4a4a4;
}
.cm_list_pagination {
  margin: 20px 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
.cm_notice_container {
  width: 100%;
  height: 320px;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  border: 1px solid rgba(225, 228, 231, 1);
  padding: 0 20px;
}

.cm_notice_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  border-bottom: 1px solid #4379d3;
}
.cm_notice_title > h3 {
  font-size: 20px;
  font-weight: 500;
  color: rgba(67, 121, 211, 1);
  line-height: 33px;
}
.cm_work_content > li {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  cursor: pointer;
}
.cm_work_content > li :hover {
  color: #4379d3;
}

.cm_work_content > li > h4 {
  width: 80%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
  font-weight: 400;
}
.cm_work_content > li > span {
  font-size: 16px;
  font-weight: 400;
  color: rgba(191, 191, 191, 1);
}
.cm_right_list {
  width: 28%;
}

.mobile_common_width{
   width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.mobile_common_width>.cm_left_list{
  width: 100%;
}
.mobile_common_width>.cm_right_list{
  margin-top: 20px;
  width: 100%;
}
</style>